import { render } from "./UpdateIntercomModal.vue?vue&type=template&id=c1a49fc2&scoped=true"
import script from "./UpdateIntercomModal.vue?vue&type=script&lang=js"
export * from "./UpdateIntercomModal.vue?vue&type=script&lang=js"

import "./UpdateIntercomModal.vue?vue&type=style&index=0&id=c1a49fc2&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a49fc2"]])

export default __exports__